export default __webpack_public_path__ + "static/StreamlinedPermittingProcesses-baf7e93c0e362a26a07a13cbac341737.jpg";